import { useEffect, useRef } from "react";
import { useMap } from "react-leaflet";
import * as L from "leaflet";
import { PositionMsgType } from "./types";

export function AutoFitBounds({ points }: { points: PositionMsgType[] }) {
  const map = useMap();
  const didFit = useRef(false);

  useEffect(() => {
    if (didFit.current || !points?.length) return;
    const valid = points.filter(p => Number.isFinite(p.gpsLatitude) && Number.isFinite(p.gpsLongitude));
    if (!valid.length) return;
    const bounds = L.latLngBounds(valid.map(p => [p.gpsLatitude, p.gpsLongitude] as [number, number]));
    map.fitBounds(bounds, { padding: [24, 24] });
    didFit.current = true;
  }, [map, points]);

  return null;
}
